<template>
  <div 
    class="fts-list-view-display fts-scrollbar fts-scrollbar-overlay" 
    :class="computedClasses"
  >
    <template v-if="model">
      <!-- yes no -->
      <div class="yes-no-display" v-if="item.type === 1">
        <font-awesome-icon class="success-theme" :icon="['fas', 'check']" fixed-width v-if="model === 'Yes'" />
      </div>
      <!-- module -->
      <div class="dropdown-display" v-else-if="item.type === 7">
        <a
          :href="getEntryURL()"
          target="_blank"
          class="lv-display-entry-link stopPropagation"
          @click.prevent="openQuickView()"
          v-if="isConnectionLink && getEntryId()"
        >
          {{model}}
        </a>
        <!-- default -->
        <template v-else>{{model}}</template>
      </div>
      <!-- locuses -->
      <div class="lv-display-dropdown lv-display-dropdown--multiple" v-else-if="item.type === 8">
        <div
          v-for="x in model"
          :key="x.id"
          class="lv-display-dropdown-tag"
        >
          <a
            :href="getEntryURL(x)"
            target="_blank"
            class="lv-display-entry-link stopPropagation"
            @click.prevent="openQuickView(x)"
            v-if="isConnectionLink && x.id"
          >
            {{x.name}}
          </a>
          <template v-else>
            {{x.name}}
          </template>
        </div>
      </div>
      <!-- location -->
      <div class="location-display" v-else-if="item.type === 9">
        <fts-tippy
          content="View location on Google Maps"
          v-if="model && model.lat && model.lng"
        >
          <a
            target="_blank"
            :href="`http://www.google.com/maps/place/${model.lat},${model.lng}`"
          >
            <font-awesome-icon :icon="['fas', 'map-marked-alt']" fixed-width />
          </a>
        </fts-tippy>
        <div class="location-name">{{model.placeName}}</div>
      </div>
      <!-- image, images -->
      <fts-file
        :prefixURL="`${vectorId}-${item.id}`" 
        :data="model"
        file-type="image"
        :max="comfortDesign ? 3 : 1"
        downloadable
        class="file-display"
        v-else-if="item.type === 10 || item.type === 11"
      />
      <!-- file, files -->
      <fts-file
        :prefixURL="`${vectorId}-${item.id}`" 
        :data="model"
        file-type="file"
        downloadable
        class="file-display"
        v-else-if="item.type === 12 || item.type === 13"
      />
      <!-- table -->
      <fts-table-view 
        :vector-id="vectorId"  
        :columns="item.fields"
        :list="model"
        v-else-if="item.type === 14 && model && model.length > 0"
      />
      <!-- list -->
      <div class="list-display" v-else-if="item.type === 15">
        <div v-for="x in model" :key="x">{{x}}</div>
      </div>
      <!-- multiline text -->
      <div class="multi-text-display" v-else-if="item.type === 16">
        <span>{{model}}</span>
      </div>
      <!-- username -->
      <fts-profile
        :user-name="model"
        profile-group
        v-else-if="item.type === 19"
      />
      <!-- profile (module) -->
      <fts-profile 
        :user-name="profileUsername" 
        v-else-if="item.type === 20"
      >
        <template #profileName="{ userProfile }">
          <a
            :href="getEntryURL()"
            target="_blank"
            class="lv-display-entry-link stopPropagation"
            @click.prevent="openQuickView()"
            v-if="isConnectionLink && getEntryId()"
          >
            {{model}}
          </a>

          <fts-display-profile-card 
            append-to-body 
            :profile="userProfile" 
            :profile-name="model" 
            append-trigger-class="stopPropagation" 
            v-else 
          />
        </template>
      </fts-profile>
      <!-- users -->
      <div
        class="lv-display-user lv-display-user--multiple"
        v-else-if="item.type === 21"
      >
        <div
          v-for="x in model"
          :key="x.id"
          class="lv-display-user-tag"
        >
          <fts-profile :user-name="x.username">
            <template #profileName="{ userProfile }">
              <a
                :href="getEntryURL(x)"
                target="_blank"
                class="lv-display-entry-link stopPropagation"
                @click.prevent="openQuickView(x)"
                v-if="isConnectionLink && x.id"
              >
                {{x.name}}
              </a>

              <fts-display-profile-card 
                append-to-body 
                :profile="userProfile" 
                :profile-name="x.name" 
                append-trigger-class="stopPropagation"  
                v-else
              />
            </template>
          </fts-profile>
        </div>
      </div>
      <!-- content -->
      <div class="display-content" v-else-if="item.type === 22" v-html="model"></div>
      <!-- email -->
      <div class="email-display contact-link-display" v-else-if="item.type === 25">
        {{model}}
        <fts-tippy
          content="Send mail"
          class="contact-link-display-shortcut"
        >
          <a :href="'mailto:' + model">
            <font-awesome-icon :icon="['far', 'envelope']" />
          </a>
        </fts-tippy>
      </div>
      <!-- phone number -->
      <div class="phone-number-display contact-link-display" v-else-if="item.type === 26">
        {{model}}
        <fts-tippy
          content="Open in WhatsApp"
          class="contact-link-display-shortcut"
        >
          <a target="_blank" :href="waLink">
            <font-awesome-icon :icon="['fab', 'whatsapp']" />
          </a>
        </fts-tippy>
      </div>
      <!-- select -->
      <div
        class="dropdown-display fts-display-form-tag"
        :style="{ 'background-color': getColor(model) }"
        v-else-if="item.type === 27 && !item.reference"
      >
        {{model}}
      </div>
      <!-- tag -->
      <div
        class="lv-display-dropdown lv-display-dropdown--multiple"
        v-else-if="item.type === 28"
      >
        <div
          v-for="x in model"
          :key="x.id"
          class="lv-display-dropdown-tag"
          :style="{ 'background-color': getColor(x) }"
        >
          {{x}}
        </div>
      </div>
      <!-- signature -->
      <fts-file 
        class="signature-display"
        :prefixURL="`${vectorId}-${item.id}`" 
        :data="model"
        file-type="image"
        file-content-class="signature-display-content"
        image-contain
        downloadable
        v-else-if="item.type === 29"/>
      <!-- link -->
      <div v-else-if="item.type === 33">
        <!-- link:query -->
        <div
          class="fts-link-primary"
          @click="toggleQueryUrl" 
          v-if="isQueryURL"
        >
          {{model.name}}
        </div>
        <!-- link:UNC -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="uNCFilePath"
          v-else-if="uNCFilePath"
        >
          {{ model.name }}
        </a>
        <!-- link:default -->
        <a
          class="fts-link-primary"
          target="_blank"
          :href="linkURL"
          v-else-if="linkURL"
        >
          {{model.name}}
        </a>
        <!-- link:name -->
        <template v-else>{{model.name}}</template>
      </div>
      <!-- default -->
      <template v-else>{{model}}</template>
    </template>
    <!-- blank -->
    <div v-else>&nbsp;</div>
  </div>
</template>

<script>
import numeral from 'numeral';

import { classificationStore } from '../store/classificationStore';
import { clientStore } from '../store/clientStore';
import commons from '../commons/commons';
import { uNCValidator } from '../commons/validator';

import FTSDisplayProfileCard from './FTSDisplayProfileCard';
import FTSFile from './file/FTSFile';
import FTSProfile from './FTSProfile';
import FTSTippy from './FTSTippy';

export default {
  store: classificationStore,
  props: {   
    formData: Object,
    item: Object,
    vectorId: [ Number, String ],
    mode: {
      type: String,
      default: "compact"
    },
    enableTextAlignment: Boolean,
    comfortDesign: Boolean,
  },
  components: {
    "fts-display-profile-card": FTSDisplayProfileCard,
    "fts-file": FTSFile,
    "fts-profile": FTSProfile,
    "fts-tippy": FTSTippy
  },
  methods: {
    /**
     * @param {Object} item for multiple only
     */
    openQuickView(item) {
      const entryId = this.getEntryId(item);
      if (entryId)
        window.eventBus.$emit("quickViewData", {
          id: entryId,
          vectorId: this.connectionId
        });
    },
    toggleQueryUrl() {
      try {
        const urlParams = new URLSearchParams(this.model.url);
        const params = Object.fromEntries(urlParams);
        if (params.d && params.id && params.v) {
          window.eventBus.$emit("showPDFDocument", {
            document: {id: params.d, typeId: 'pdf'},
            items: [{id: params.id}],
            moduleId: params.v
          });
        }
      } catch(err) {
        console.warn("ListViewDisplay:ToggleQueryUrl", err);
      }
    },
    /**
      * @param {String} text
      */
    getColor(text) {
      return commons.selectOptionBackground({
        optionList: this.item.optionList,
        text: text,
      });
    },
    /**
     * @param {Object} item for multiple only
     */
    getEntryId(item) {
      return (this.item.type === 8 || this.item.type === 21)
        ? item.id
        : commons.model(this.formData, this.item.fieldName, true);
    },
    /**
     * @param {Object} item for multiple only
     */
    getEntryURL(item) {
      const entryId = this.getEntryId(item);
      return entryId && `/#/dashboard?id=${commons.queryEncodeids(this.connectionId, entryId)}`;
    },
  },
  computed: {
    model() {
      const result = commons.model(this.formData, this.item.fieldName);
      if (result) {
        /* date */
        if (this.item.type === 5) {
          if (this.item.predefinedFormatId)
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate(this.item.predefinedFormatId));
          else 
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate("DD"));
        }
        /* date time */
        else if (this.item.type === 6) {
          if (this.item.predefinedFormatId)
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate(this.item.predefinedFormatId));
          else 
            return luxon.fromISO(result).toFormat(commons.dateFormatTranslate("DD t"));
        }
        /* table */
        else if (this.item.type === 14 && !result.length) {
          return null;
        } 
        /* list */
        else if (this.item.type === 15)  {    
          if (result.length) {
            function remap(fieldName) {
              return result.map(x => x[fieldName]).filter(y => y)
            }
            // displayField
            if (this.item.displayField) {
              const field = this.item.fields.find(x => x.displayName === this.item.displayField)
              if (field.fieldName)
                return remap(field.fieldName)
            }
            // default
            const fields = this.item.fields.filter(
              x => [0, 1, 2, 3, 4, 5, 6, 7, 9, 16, 19, 20, 25, 26, 27, 33].some(y => y === x.type)
            )
            if (fields.length) 
              return remap(fields[0].fieldName)
          }
          return []
        } 
        /* yes no */
        else if (this.item.type === 1) {
          return result ? "Yes" : "No";
        }
        /* number */
        else if (this.item.type === 3) {
          if (this.item.customFormat) {
            return numeral(result).format(this.item.customFormat);
          } else if (this.item.displayFormat) {
            return numeral(result).format(this.item.displayFormat);
          } else {
            const decimalPlaces = commons.isInteger(this.item.decimalPlaces) ? this.item.decimalPlaces : 2;
            return result.toLocaleString(undefined, {
              minimumFractionDigits: decimalPlaces,
              maximumFractionDigits: decimalPlaces,
            });
          }
        }
        /* money */
        else if (this.item.type === 4) {
          return numeral(result).format("0,0.00");
        }
        /* location */
        else if (this.item.type == 9) {
          /* for old data */
          return {
            lat: result.lat ? result.lat : result.latitude,
            lng: result.lng ? result.lng : result.longitude,
            placeName: result.placeName,
          };
        }
        // phone number
        else if (this.item.type == 26) {
          if (typeof result === "number") {
            return String(result);
          } else if (typeof result !== "string" || !result.trim()) {
            return null;
          } else {
            return result;
          }
        }
        /* link */
        else if (this.item.type === 33) {
          if (result.constructor === String)
            return {
              url: result,
              name: result,
            };
          else if (result.constructor == Object) 
            return result.name === null || result.name === undefined ?
              {...result, name: '(undefined)'} : result;

          return { name: 'invalid URL' }
        }
        /* default */
        return result;
      } else if (this.item.type === 1 && result === false) {
        return "No";
      }
      else if ((this.item.type === 2 || this.item.type === 3) && result === 0) {
        return "0";
      } 
      else if (this.item.type === 4 && result === 0) {
        return "0.00";
      } else {
        return null;
      }
    },
    computedClasses() {
      return [
        { condition: this.comfortDesign, className: "comfort-design" },
        { condition: this.item.wrap || this.comfortDesign, className: "list-view-display--wrap" },
        { 
          condition: this.enableTextAlignment && this.item.type == 4,
          className: "list-view-display--text-right"
        },
      ]
        .filter(x => x.condition)
        .map(x => x.className)
        .join(" ");
    },
    connectionId() {
      if (this.item.wildcard !== true)
        return this.item.connectionId;
    },
    profileUsername() {
      return commons.model(this.formData, `${this.item.fieldName}Username`);
    },
    locusURL() {
      const entryId = commons.model(this.formData, this.item.fieldName, true);
      return entryId && `/#/dashboard?id=${commons.queryEncodeids(this.connectionId, entryId)}`;
    },
    /* WhatsApp link */
    waLink() {
      return this.model && `https://wa.me/${this.model.replace(/\D+/g, '')}`;
    },
    /* link */
    isQueryURL() {
      return Boolean(
        this.model && 
        this.model.url && 
        this.model.url.startsWith("?")
      );
    },
    linkURL() {
      if (this.model && this.model.url)
        return this.model.url.toLowerCase().startsWith("http") ? this.model.url : `//${this.model.url}`
    },
    uNCFilePath() {
      if (this.model && this.model.url && uNCValidator(this.model.url)) {
        if (/^([a-zA-Z]\:\\|\\\\)/g.test(this.model.url))
          return `ist://${encodeURIComponent(this.model.url)}`;
        else
          return `file:///${this.model.url}`;
      }
    },
    isConnectionLink() {
      const connectionId = this.item && this.item.connectionId;
      return clientStore.getters.availableModules.some(x => x == connectionId);
    }
  },
  beforeCreate: function () {
    this.$options.components.FtsTableView = require("./views/FTSTableView").default;
  },
  mounted() {
    try {
      if (this.$el.scrollWidth > this.$el.clientWidth) {
        this.$el.style.paddingBottom = "0.5rem";
      }
    } catch(err) {
      console.warn("[DOMException]", err);
    }
  }
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.fts-list-view-display {
  font-size: var(--inistate-label-text-14);
  line-height: var(--inistate-paragraph-text-14--line-height);
  word-break: break-word;
  .fts-display-form-tag {
    width: auto;
    display: inline-flex;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    border-radius: 0.25rem;
    color: var(--fts-dark);
  }
  .yes-no-display {
    .success-theme {
      color: var(--fts-success);
    }
    .danger-theme {
      color: var(--fts-danger);
    }
  }
  .list-display {
    @include flex-gap($gap: .375rem, $wrap: nowrap);
    min-width: 0;
    > div {
      @include text-overflow-ellipsis;
      padding: .15rem .175rem;
      background-color: var(--fts-gray-300);
      border-radius: .25rem;
    }
  }
  .multi-text-display {
    span {
      white-space: pre;
    }
  }
  .location-display {
    display: flex;
    align-items: baseline;
    a {
      color: var(--fts-primary);
    }
    .location-name {
      margin-left: 0.5rem;
    }
  }
  .file-display {
    .file-container {
      flex-wrap: nowrap;
    }
  }
  .contact-link-display {
    display: flex;
    align-items: center;
    .contact-link-display-shortcut {
      margin-left: 0.375rem;
      visibility: hidden;
    }
    a {
      display: flex;
      color: var(--fts-default);
      svg {
        // font-size: 1rem;
      }
      &:hover {
        color: var(--fts-primary);
      }
    }
    &:hover .contact-link-display-shortcut {
      visibility: visible;
    }
  }
  .signature-display {
    .signature-display-content {
      border: 1px solid var(--fts-border);
    }
  }
  &.list-view-display--wrap {
    white-space: normal;
    > .location-display {
      white-space: normal;
    }
    > .multi-text-display {
      span {
        white-space: pre-wrap;
      }
    }
  }
  &.list-view-display--text-right {
    text-align: right;
  }
}
/* to-do merge */
.fts-list-view-display {
  .lv-display-entry-link {
    text-decoration: none;
    color: var(--fts-primary);
  }
  .lv-display-dropdown {
    &.lv-display-dropdown--multiple {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      .lv-display-dropdown-tag {
        margin-bottom: 0.375rem;
        margin-right: 0.375rem;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        border-radius: 0.25rem;
        background-color: var(--fts-gray-100);
        color: var(--fts-dark);
      }
    }

  }
  .lv-display-user {
    &.lv-display-user--multiple {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      .lv-display-user-tag {
        margin-bottom: 0.375rem;
        margin-right: 0.375rem;
        padding-left: 0.25rem;
        padding-right: 0.25rem;
        border-radius: 0.25rem;
        background-color: var(--fts-gray-100);
      }
    }
  }
}
</style>